export const COLS = [
  { id: 'firstName', title: 'First Name', canOrder: true, lookupField: 'FirstName' },
  { id: 'lastName', title: 'Lasst Name', canOrder: true, lookupField: 'LastName' },
  { id: 'cycle', title: 'Program Cycle', canOrder: true, lookupField: '_PROGRAMCYCLESINTERNALUSE' },
  { id: 'dates', title: 'Program Dates', canOrder: true, lookupField: '_SESSIONSTARTDATE' },
  { id: 'notes', title: 'Notes for Resort', canOrder: true, lookupField: '_NOTESFORTHERESORT0' },
  { id: 'room', title: 'Room #', canOrder: true, lookupField: '_ROOMNUMBER0' },
  { id: 'area', title: 'Speciality', canOrder: true, lookupField: '_AreaoffocusPhysicalEmotionalHabits' },
];
